var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-view',{staticClass:"h-100"})
}
var staticRenderFns = []

export { render, staticRenderFns }